import Brands from "./Brands/Brands";
import Category from "./Category/Category";
import Consumption from "./Consumption/Consumption";
import Godown from "./Godown/Godown";
import Products from "./Product/Products";
import ProductIngredients from "./ProductIngredients/ProductIngredients";

export default { Products, Category, Godown, Brands, Consumption, ProductIngredients };
